import { StateCreator } from 'zustand'
import { SharedSlice } from 'src/components/slice'
import { LoaderFunctionArgs } from 'react-router-dom'
import useStockStore from '../../../store'
import { convertPurchaseOrderToPurchaseOrderUi } from '../helpers/helper'

export interface EditPurchaseOrdersSlice extends EditPurchaseOrdersState {
  resetEditPurchaseOrdersSlice: () => void

  initializePurchaseOrderData: (
    loaderFunctionArgs: LoaderFunctionArgs
  ) => Promise<void>
}

interface EditPurchaseOrdersState {}

const initialEditPurchaseOrdersState: EditPurchaseOrdersState = {}

export const purchaseOrderSlice: StateCreator<
  EditPurchaseOrdersSlice & SharedSlice,
  [],
  [],
  EditPurchaseOrdersSlice
> = (set) => ({
  ...initialEditPurchaseOrdersState,

  resetEditPurchaseOrdersSlice: () => set(initialEditPurchaseOrdersState),

  initializePurchaseOrderData: async ({ params }) => {
    const { getPurchaseOrder } = useStockStore.getState()

    const purchaseOrderId = params.purchaseOrderId

    if (!purchaseOrderId) return

    const purchaseOrder = await getPurchaseOrder(purchaseOrderId)

    if (!purchaseOrder) return

    const purchaseOrderUi = convertPurchaseOrderToPurchaseOrderUi(purchaseOrder)

    const { setPurchaseOrderUi } = useStockStore.getState()

    setPurchaseOrderUi(purchaseOrderUi)
  },
})

export default purchaseOrderSlice
